export default "__VITE_ASSET__BJdpodVF__"